import { SmartTableColumn, WithNAFallback } from '@toggle/design-system';
import { EarningsInsightRating, RecapKpi } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RatingPill } from '../../../components/rating-pill/RatingPill';
import { SharedTable } from '../../../components/shared-table/SharedTable';
import * as S from './KpisTable.styles';

interface KpisTableProps {
  kpisData: RecapKpi[];
}

export const KpisTable = ({ kpisData }: KpisTableProps) => {
  const { t } = useTranslation(['earnings']);

  const tableData = (kpisData || []).map((item, index) => ({
    ...item,
    key: `kpi-${index}`,
  }));

  const tableColumns: SmartTableColumn<RecapKpi>[] = [
    {
      key: 'title',
      label: t('earningsInsight.drawer.earningsRecap.tables.kpi'),
      render: (value: string) => (
        <WithNAFallback
          check={value !== undefined && value !== ''}
          value={<S.StyledTitleCell>{value}</S.StyledTitleCell>}
        />
      ),
    },
    {
      key: 'value',
      label: t('earningsInsight.drawer.earningsRecap.tables.value'),
      render: (value: string) => (
        <WithNAFallback
          check={value !== undefined && value !== ''}
          value={<S.ValueCell>{value}</S.ValueCell>}
        />
      ),
    },
    {
      key: 'description',
      label: t('earningsInsight.drawer.earningsRecap.tables.description'),
      render: (value: string) => (
        <WithNAFallback
          value={
            value && <S.StyledDescriptionCell>{value}</S.StyledDescriptionCell>
          }
        />
      ),
    },
    {
      key: 'rating',
      label: t('earningsInsight.drawer.earningsRecap.tables.impact'),
      render: (value?: EarningsInsightRating) => (
        <WithNAFallback
          value={
            value && (
              <S.StyledRatingPill>
                <RatingPill rating={value} />
              </S.StyledRatingPill>
            )
          }
        />
      ),
    },
  ];

  return (
    <>
      <S.Title>
        {t('earnings:earningsInsight.drawer.earningsRecap.items.kpisInFocus')}
      </S.Title>
      <SharedTable
        tableData={tableData}
        tableColumns={tableColumns}
        noCellPadding
      />
    </>
  );
};
